export enum AutoplayEvent {
    ENABLED = 'onAutoplayEnabled',
    DISABLED = 'onAutoplayDisabled',
    SPINS_LEFT_CHANGED = 'onAutoplaySpinsLeftChanged',
}
